import { render, staticRenderFns } from "./LingueListPage.vue?vue&type=template&id=189bcd43"
import script from "./LingueListPage.vue?vue&type=script&lang=js"
export * from "./LingueListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports